// process.env.NODE_ENV === 'production' ? console.log('Production mode!') : require('__page/index.html');
const mc = require('__libs/ModuleConstructor.js');
mc.runVue(['Slider', 'Navigation']);
mc.runComponents(['rating']);
mc.runFooter();


// WEBPACK FOOTER //
// ./entries/news-detail-xl.js